{
  "CONTACTS_FILTER": {
    "TITLE": "Filtrar contactos",
    "SUBTITLE": "Añada filtros a continuación y pulse 'Enviar' para filtrar contactos.",
    "EDIT_CUSTOM_SEGMENT": "Editar segmento",
    "CUSTOM_VIEWS_SUBTITLE": "Agregar o quitar filtros y actualiza tu segmento.",
    "ADD_NEW_FILTER": "Añadir Filtro",
    "CLEAR_ALL_FILTERS": "Limpiar todos los filtros",
    "FILTER_DELETE_ERROR": "Debes tener al menos un filtro para guardar",
    "SUBMIT_BUTTON_LABEL": "Enviar",
    "UPDATE_BUTTON_LABEL": "Actualizar segmento",
    "CANCEL_BUTTON_LABEL": "Cancelar",
    "CLEAR_BUTTON_LABEL": "Limpiar filtros",
    "EMPTY_VALUE_ERROR": "El valor es requerido",
    "SEGMENT_LABEL": "Nombre del segmento",
    "SEGMENT_QUERY_LABEL": "Consulta de segmentos",
    "TOOLTIP_LABEL": "Filtrar contactos",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "Y",
      "OR": "O"
    },
    "OPERATOR_LABELS": {
      "equal_to": "Igual a",
      "not_equal_to": "No igual a",
      "contains": "Contiene",
      "does_not_contain": "No contiene",
      "is_present": "Está presente",
      "is_not_present": "No está presente",
      "is_greater_than": "Es mayor que",
      "is_lesser_than": "Es menor que",
      "days_before": "Es X días antes"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "El valor es requerido"
    },
    "ATTRIBUTES": {
      "NAME": "Nombre",
      "EMAIL": "E-mail",
      "PHONE_NUMBER": "Número de teléfono",
      "IDENTIFIER": "Idenrificador",
      "CITY": "Ciudad",
      "COUNTRY": "País",
      "CUSTOM_ATTRIBUTE_LIST": "Lista",
      "CUSTOM_ATTRIBUTE_TEXT": "Texto",
      "CUSTOM_ATTRIBUTE_NUMBER": "Número",
      "CUSTOM_ATTRIBUTE_LINK": "Enlace",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Casilla",
      "CREATED_AT": "Creado el",
      "LAST_ACTIVITY": "Última actividad",
      "REFERER_LINK": "Enlace de referencia",
      "BLOCKED": "Bloqueado",
      "LABELS": "Etiquetas"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Filtros estándar",
      "ADDITIONAL_FILTERS": "Filtros adicionales",
      "CUSTOM_ATTRIBUTES": "Atributos personalizados"
    }
  }
}
